// let epeida_url_config = "https://uat.szepeida.com/epeida-service"
// let epeida_url_config = "http://localhost:8082"
let epeida_url_config = "https://e.myd0755.com/epeida-service"



export default epeida_url_config